/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React, { useEffect, useState } from 'react';

const services = [
  {
    title: 'Responsive Website',
    text: 'A clean WordPress front end that adapts to the business, brand, and content model.'
  },
  {
    title: 'Editable Content',
    text: 'Pages, posts, menus, logos, and brand colors stay manageable inside WordPress admin.'
  },
  {
    title: 'AWS Ready',
    text: 'Terraform provisions the web server, private MySQL database, and bootstrap process.'
  }
];

export default function BusinessApp({ settings }) {
  const [posts, setPosts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const restUrl = settings.restUrl;

    if (!restUrl) {
      setLoaded(true);
      return;
    }

    fetch(`${restUrl}wp/v2/posts?per_page=3&_fields=id,link,title,excerpt`)
      .then((response) => (response.ok ? response.json() : []))
      .then((items) => setPosts(Array.isArray(items) ? items : []))
      .catch(() => setPosts([]))
      .finally(() => setLoaded(true));
  }, [settings.restUrl]);

  return (
    <div className="business-app">
      <div className="section-heading">
        <p>{settings.phone ? settings.phone : settings.siteName}</p>
        <h2>Built for the work your business does every day.</h2>
      </div>

      <div className="card-grid">
        {services.map((service) => (
          <article className="service-card" key={service.title}>
            <h3>{service.title}</h3>
            <p>{service.text}</p>
          </article>
        ))}
      </div>

      {loaded && posts.length > 0 && (
        <div className="latest-posts">
          <div className="section-heading section-heading--compact">
            <p>Latest</p>
            <h2>News and updates</h2>
          </div>
          <div className="card-grid">
            {posts.map((post) => (
              <article className="post-card" key={post.id}>
                <h3>
                  <a href={post.link} dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                </h3>
                <p dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
              </article>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
